import DocumentsResourcesCollection from "./entity-collections/documents"
import CRMContactsResourcesCollection from "./entity-collections/crm-contacts"
import CRMAccountsResourcesCollection from "./entity-collections/crm-accounts"
import RemindersResourcesCollection from "./entity-collections/reminders"
import MeetingsResourcesCollection from "./entity-collections/meetings"
import EventsResourcesCollection from "./entity-collections/events"
import ProjectUpdatesResourcesCollection from "./entity-collections/project-updates"
import TaskUpdatesResourcesCollection from "./entity-collections/task-updates"
import TasksResourcesCollection from "./entity-collections/tasks"
import resourcesSessionLoader from "./session-loader"
import TimeReportsResourcesCollection from "./entity-collections/time-reports"
import TimeReport from "../model2/time-report/time-report"
import ProjectsResourcesCollection from "./entity-collections/projects"
import DependenciesResourcesCollection from "./entity-collections/dependencies";
import {resources_initSuccessorsPredecessors} from "./actions/init-successors-predecessors";
import ExpensesResourcesCollection from "./entity-collections/expenses";
import Expense from "../model2/expenses/expense/expense";
import {EntityType} from "../gd/const/item";
import ResourcesDeltaHandler from "./delta-handler/resources-delta-handler";
import RelevanceSettings from "../gd/manager/delta-handler/relevance-settings";
import Meeting from "../model2/meeting/meeting";
import {DeltaEventMethodType, UpdateAction, UpdateType} from "../gd/manager/delta-handler/types";
import ModelEntity from "../model2/model-entity";
import resourcesProcessUpdates from "./delta-handler/process-updates";

// const debug = "Resources"
const debug = false

export default class Resources {

    public tasks            : TasksResourcesCollection | null = null
    public taskUpdates      : TaskUpdatesResourcesCollection | null = null
    public projects         : ProjectsResourcesCollection | null = null
    public projectUpdates   : ProjectUpdatesResourcesCollection | null = null
    public events           : EventsResourcesCollection | null = null
    public meetings         : MeetingsResourcesCollection | null = null
    public reminders        : RemindersResourcesCollection | null = null
    public documents        : DocumentsResourcesCollection | null = null
    public crmAccounts      : CRMAccountsResourcesCollection | null = null
    public crmContacts      : CRMContactsResourcesCollection | null = null
    public timeReports      : TimeReportsResourcesCollection | null = null
    public dependencies     : DependenciesResourcesCollection | null = null
    public expenses         : ExpensesResourcesCollection | null = null

    public _ridMap                  : any   =  {}

    private deltaHandler?           : ResourcesDeltaHandler
    public deltaHandlerCallback?   : callback

    public relevanceSettings?       : RelevanceSettings

    constructor() {

    }

    public destroy() {
        gd.modelBus.unsubscribe(this)
        this.deltaHandler?.destructor()
    }



    getAllResources(collections:string[]): any[] {
        let res:any[] = []

        _.map(collections, (collectionName:string): void=>{
            // @ts-ignore
            if (this[collectionName]) res = res.concat(this[collectionName].models)
            else console.warn("Resources getAllResources: collection not found", collectionName)
        })

        return res
    }

    /** METHODS **/

    get(rid:RID):ModelEntity {
        return this._ridMap[rid]
    }

    // RESET collections

    resetTasks(data:JSONArray, options={}) {
        if (this.tasks) {
            this.tasks.reset(data, options)
        }
        else this.tasks = new TasksResourcesCollection(this, data, options)
    }

    resetProjects(data:JSONArray, options={}) {
        if (this.projects) { this.projects.reset(data, options) }
        else this.projects = new ProjectsResourcesCollection(this, data, options)
    }

    resetEvents(data:JSONArray, options={}) {
        if (this.events) { this.events.reset(data, options) }
        else this.events = new EventsResourcesCollection(this, data, options)
    }

    resetReminders(data:JSONArray, options={})    {
        if (this.reminders) { this.reminders.reset(data, options) }
        else this.reminders = new RemindersResourcesCollection(this, data, options)
    }

    resetMeetings(data:JSONArray, options={})     {
        if (this.meetings) { this.meetings.reset(data, options) }
        else this.meetings = new MeetingsResourcesCollection(this, data, options)
    }

    resetContacts(data:JSONArray, options={})     {
        if (this.crmContacts) { this.crmContacts.reset(data, options) }
        else this.crmContacts = new CRMContactsResourcesCollection(this, data, options)
    }

    resetAccounts(data:JSONArray, options={})     {
        if (this.crmAccounts) { this.crmAccounts.reset(data, options) }
        else this.crmAccounts = new CRMAccountsResourcesCollection(this, data, options)
    }

    resetDocuments(data:JSONArray, options={})    {
        if (this.documents) { this.documents.reset(data, options) }
        else this.documents = new DocumentsResourcesCollection(this, data, options)
    }

    resetTaskUpdates(data:JSONArray,options={})              {
        if (this.taskUpdates) { this.taskUpdates.reset(data, options) }
        else this.taskUpdates = new TaskUpdatesResourcesCollection(this, data, options)
    }

    resetProjectUpdates(data:JSONArray,options={})           {
        if (this.projectUpdates) { this.projectUpdates.reset(data, options) }
        else this.projectUpdates = new ProjectUpdatesResourcesCollection(this, data, options)
    }

    resetTimeReports(data:JSONArray, options:any={}) {
        if (this.timeReports) {
            this.timeReports.reset(data, options)
            // console.log("Time reports reset done lenght=", this.timeReports.length)
        }
        else {
            this.timeReports = new TimeReportsResourcesCollection(this, data, options)
        }
    }

    resetDependencies(data:JSONArray, options:any={}) {
        if (this.dependencies) { this.dependencies.reset(data, options) }
        else this.dependencies = new DependenciesResourcesCollection(this, data, options)
    }

    resetExpenses(data:JSONArray, options={}) {
        if (this.expenses) { this.expenses.reset(data, options) }
        else this.expenses = new ExpensesResourcesCollection(this, data, options)
    }

    // MISSING DATA

    async loadMissingData(options?:any):Promise<boolean> {
        const sessionLoaderPromise = resourcesSessionLoader(this.findMissingData(options))
        return sessionLoaderPromise
    }

    public findMissingData(options?:any) {
        let allUsers                : string[] = []
        let allTaskTypes            : string[] = []
        let allStatuses             : string[] = []
        let allProjects             : string[] = []
        let allProjectsWithParents  : ID[] = []
        let allNoteTypes            : string[] = []
        let allCustomFields         : string[] = []
        let allExpenseCategories    : ID[] = []

        this.tasks && _.map(this.tasks.models,task=>{
            if (task.taskTypeId)    allTaskTypes.push(task.taskTypeId)
            if (task.statusId)      allStatuses.push(task.statusId)

            // Projects
            const searchProjectsWithParents = _.get(options,'taskProjectWithParents', false)
            if (searchProjectsWithParents) {
                allProjectsWithParents.push(task.projectId)
            } else {
                allProjects.push(task.projectId)
            }

            const cfData = task.customFieldsData
            for(let prop in cfData){ if (cfData.hasOwnProperty(prop)) allCustomFields.push(prop) }

            const taskType = gd.session.taskTypes.get(task.taskTypeId)
            if (taskType) allCustomFields = _.union(allCustomFields, taskType.customFields)
        })

        this.taskUpdates && _.map(this.taskUpdates.models, taskUpdate=>{
            const { fromUserId, toUserId, taskStatusId } = taskUpdate.taskMessage
            if (fromUserId)     allUsers.push(fromUserId)
            if (toUserId)       allUsers.push(toUserId)
            if (taskStatusId)   allStatuses.push(taskStatusId)
        })

        let involvedProjects: ID[] = []
        this.projects && _.map(this.projects.models,project=>{
            if (project.statusId)       allStatuses.push(project.statusId)
            if (project.ownerUserId)    allUsers.push(project.ownerUserId)

            _.map(project.users, user=>{
                allUsers.push(user.userId)
            })

            allTaskTypes = allTaskTypes.concat(project.taskTypes)
            allProjects.push(project.id) // required in case of archived project

            involvedProjects = involvedProjects.concat(gd.tree.findProjectParents(gd.tree.getProject(project.id)).map((p:any)=>p.id)).concat([project.id])
            involvedProjects = involvedProjects.concat(gd.tree.findProjectChildren(project.id).map((p:any)=>p.id))
        })

        involvedProjects = _.uniq(involvedProjects)
        _.map(involvedProjects, pId=>{
            const project = gd.session.projects.get(pId)
            if (project && project.localTemplateId) {
                allCustomFields = allCustomFields.concat(project.customFields)
                allProjects.push(project.localTemplateId)
            }
        })

        this.expenses && _.map(this.expenses.models, (expense:Expense)=>{
            allProjects.push(expense.projectId)
            allUsers.push(expense.userId)
            allExpenseCategories.push(expense.expenseCategoryId)
        })

        this.documents && _.map(this.documents.models, document=>{
            allProjects.push(document.projectId)
            allUsers = _.union(allUsers,document.editors)
            allNoteTypes.push(document.noteTypeId)
        })

        this.timeReports && _.map(this.timeReports.models, (timeReport:TimeReport)=>{
            allUsers.push(timeReport.userId)
        })

        this.events && _.map(this.events.models,event=>{
            allProjects.push(event.projectId)
            allUsers.push(event.assignedToUserId)
            allUsers.push(event.userId)
        })

        // Process meetings
        this.meetings && _.map(this.meetings.models, (meeting:Meeting)=>{

            meeting.projectId && allProjects.push(meeting.projectId)

            _.map(meeting.users?.models, user=>{
                allUsers.push(user.userId);
            })
        })

        return gd.session.findMissing({
            users               : _.uniq(allUsers),
            taskTypes           : _.uniq(allTaskTypes),
            statuses            : _.uniq(allStatuses),
            projects            : _.uniq(allProjects),
            noteTypes           : _.uniq(allNoteTypes),
            projectsWithParents : _.uniq(allProjectsWithParents),
            customFields        : _.uniq(allCustomFields),
            expenseCategories   : _.uniq(allExpenseCategories)
        })
    }

    // this method set successors and predecesors fields based on dependencies
    public initSuccessorsPredecessors() {
        resources_initSuccessorsPredecessors(this)
    }


    // Delta & Session sync

    public subscribeToSessionEvents(entities: EntityType[], callback:callback) {

        debug && console.log(debug, "subscribeToSessionEvents()")

        // destroy if exists & kill all model bus subscriptions
        if (this.deltaHandler) {
            this.deltaHandler.destructor()
        }

        this.deltaHandler           = new ResourcesDeltaHandler(this, entities)
        this.deltaHandlerCallback   = callback
    }


    processUpdates(updates:(false|undefined|UpdateAction)[]) {
        resourcesProcessUpdates(this, updates)
    }


    // Experimental Resources DeltaHandeler vic - Start

    // public subscribeToDeltaEvents(entity: EntityType | 'string', validator:deltaValidatorFunc, callback:callback) {
    //     gd.modelBus.subscribe(entity, this, this.onDeltaEvent.bind(this, validator, entity, callback))
    // }

    // private onDeltaEvent(validator:deltaValidatorFunc, entity:EntityType|string, callback:callback, method:DeltaEventMethodType, data:any, header:any) {
    //
    //     debug && console.log(debug, "onDeltaEvent entity=", entity, "method=", method)
    //
    //     if (!validator(header.expense)) {
    //         // console.brown(555, "delta event didnt pass validator")
    //     }
    //
    //
    //     switch (entity) {
    //         case EntityType.EXPENSE:
    //
    //             debug && console.log("this is expense (now call apply delta) ", data, header.expense)
    //
    //
    //             this.expenses?.applyDelta(method, data, header.expense)
    //             callback()
    //             break
    //     }
    //
    //
    // }



    // Experimental Resources DeltaHandeler vic - End



}
